import util from '../util'

let controller = 'DevolucaoTituloArquivo'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
  GetById: function (codigo) {
    return util.Axios.Get(controller + `/GetByCodigo/${codigo}`)
  },
  CreditarBoletos: function (dto) {
    return util.Axios.Post(controller + '/Creditar', dto)
  },
  CancelarBoletos: function (dto) {
    return util.Axios.Post(controller + '/Cancelar', dto)
  }
})
